import * as React from 'react'
import Autocomplete from '@mui/material/Autocomplete'
import TextField from '@mui/material/TextField'
import Stack from '@mui/material/Stack'
import Checkbox from '@mui/material/Checkbox'
import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank'
import CheckBoxIcon from '@mui/icons-material/CheckBox'
import Typography from '@mui/material/Typography'
import { useTranslation } from 'react-i18next'

import { useAppDispatch, useAppSelector } from 'redux/Hook'
import { updateQuestions } from 'redux/slices/SignUpQuestions'
import DateQuestion from './DateQuestion'

type QuestionEquality = { [key: string]: string }

const Questions = () => {
  const { questions } = useAppSelector((state) => state.signUpQuestions)
  const dispatch = useAppDispatch()
  const { t } = useTranslation()

  const handleChange = (params: {
    value: SignupFormQuestionOptions[]
    questionId: string
  }) => {
    const { value, questionId } = params

    const updatedQuestions = questions.map((savedQuestion) => {
      if (savedQuestion.id === questionId) {
        return {
          ...savedQuestion,
          value,
        }
      }

      return savedQuestion
    })

    dispatch(updateQuestions(updatedQuestions))
  }

  if (!questions.length) {
    return (
      <Typography variant="button" display="block" mt={6} textAlign={'center'}>
        {t('participant.signUpQuestions.emptyText')}
      </Typography>
    )
  }

  const isOptionEqualToValue = (
    option: QuestionEquality,
    value: QuestionEquality,
  ) => {
    return option.name === value.name
  }

  const getNonDeletedOptions = (questionOptions: []) => {
    return questionOptions.filter((option: IndexType) => !option.deleted)
  }

  return (
    <Stack spacing={3}>
      {questions.map((signUpQuestion) => {
        const { question, value, questionOptions, id, type } = signUpQuestion

        if (type === 'DateQuestion') {
          return <DateQuestion question={signUpQuestion} key={id} />
        }

        return (
          <Autocomplete
            key={id}
            multiple
            value={value}
            id="sign-up-questions"
            openText={t('filters.ariaTexts.open')}
            closeText={t('filters.ariaTexts.close')}
            clearText={t('filters.ariaTexts.clear')}
            options={getNonDeletedOptions(questionOptions)}
            onChange={(_, value) => handleChange({ value, questionId: id })}
            getOptionLabel={(option) => option.name}
            isOptionEqualToValue={isOptionEqualToValue}
            renderInput={(params) => (
              <TextField {...params} variant="standard" label={question} />
            )}
            ChipProps={{ color: 'primary' }}
            renderOption={(props, option, { selected }) => (
              <li {...props}>
                <Checkbox
                  icon={<CheckBoxOutlineBlankIcon fontSize="small" />}
                  checkedIcon={<CheckBoxIcon fontSize="small" />}
                  sx={{ mr: 1 }}
                  checked={selected}
                />
                {option.name}
              </li>
            )}
          />
        )
      })}
    </Stack>
  )
}

export default Questions
